interface IClientColors {
    bgPrimary: string;
    bgSecondary: string;
    borderPrimary: string;
    borderSecondary: string;
    hoverPrimary: string;
    hoverQuaternary: string;
    hoverSecondary: string;
    hoverTertiary: string;
    primary: string;
    secondary: string;
    surfaceCard: string;
    surfaceDefault: string;
    surfaceGlass: string;
    text: string;
}

interface IClientTheme {
    colors: IClientColors;
    hiddenProductNames?: string[];
    logoUrl: string;
    name: string;
    slug: string;
}

const DEFAULT_COLORS: IClientColors = {
    primary: '#6441da',
    bgPrimary: '#6441da',
    bgSecondary: '#F5F0FF',
    borderPrimary: '#C4ADF8',
    borderSecondary: '#9B7AEA',
    hoverPrimary: '#7B55E3',
    hoverSecondary: '#F5F0FF',
    hoverTertiary: '#A070FF',
    hoverQuaternary: '#EDE6FF',
    secondary: '#C4ADF8',
    surfaceGlass: '#E8E2FE',
    surfaceCard: '#FFE6FF',
    surfaceDefault: '#F5F0FF',
    text: '#6441da',
};

const CLIENT_REGISTRY: IClientTheme[] = [
    {
        slug: 'default',
        name: 'Your Company',
        logoUrl: '/clients/default/logo.svg',
        colors: DEFAULT_COLORS,
    },
    {
        slug: 'cupkiller',
        name: 'CupKiller',
        logoUrl: '/clients/cupkiller/logo.svg',
        colors: {
            ...DEFAULT_COLORS,
            primary: '#22434c',
            bgPrimary: '#22434c',
            bgSecondary: '#e8f0f2',
            borderPrimary: '#8ab5bf',
            borderSecondary: '#4d8090',
            hoverPrimary: '#2d5565',
            hoverSecondary: '#e8f0f2',
            hoverTertiary: '#5a9aaa',
            hoverQuaternary: '#d0e8ed',
            secondary: '#8ab5bf',
            surfaceGlass: '#c5dfe4',
            surfaceCard: '#e8f0f2',
            surfaceDefault: '#f0f6f8',
            text: '#22434c',
        },
    },
    {
        slug: 'gobeletcup',
        name: 'GobeletCup',
        logoUrl: '/clients/gobeletcup/logo.png',
        hiddenProductNames: ['faire_part'],
        colors: {
            ...DEFAULT_COLORS,
            primary: '#11af9b',
            bgPrimary: '#11af9b',
            bgSecondary: '#e6f7f4',
            borderPrimary: '#8ad9cf',
            borderSecondary: '#4dc4b5',
            hoverPrimary: '#17c2ac',
            hoverSecondary: '#e6f7f4',
            hoverTertiary: '#3fd0bf',
            hoverQuaternary: '#d2f0eb',
            secondary: '#8ad9cf',
            surfaceGlass: '#c5ebe5',
            surfaceCard: '#e6f7f4',
            surfaceDefault: '#f0faf8',
            text: '#11af9b',
        },
    },
    // Ajouter les clients ici :
    // {
    //     slug: 'mon-client',
    //     name: 'Mon Client',
    //     logoUrl: '/clients/mon-client/logo.svg',
    //     colors: {
    //         ...DEFAULT_COLORS,
    //         primary: '#E84444',
    //         bgPrimary: '#E84444',
    //         text: '#E84444',
    //         hoverPrimary: '#C93333',
    //         // ...
    //     },
    // },
];

function getClientBySlug(slug: string): IClientTheme {
    return CLIENT_REGISTRY.find((c) => c.slug === slug) ?? CLIENT_REGISTRY[0];
}

function isKnownClientSlug(slug: string): boolean {
    return CLIENT_REGISTRY.some((c) => c.slug === slug);
}

export { getClientBySlug, isKnownClientSlug };

export type { IClientColors, IClientTheme };
